/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The strings used for the Digital asset management capability.
 */
export const DAM_CAPABILITY_STRINGS = {
  altTitle: `digital asset management`,
  dialogBlurb: `lets you store, manage and serve your digital assets used in your digital experiences.`,
  dialogBullet1: `Securely manage your files.`,
  dialogBullet2: `Manage private and public permissions.`,
  dialogBullet3: `Organize your directories.`,
  subtitle: `Store, manage and serve digital assets.`,
  title: `Digital asset management`,
};
